module.exports = __webpack_public_path__ + "static/media/scoiataelBorder.f6cb2a30.png";